import { Component } from 'react';
import PropTypes from 'prop-types';
import { notEmpty } from 'ramda-extension';
import { connect } from 'react-redux';
import { createAction } from 'redux-actions';

import { codelistActionTypes } from '@gef-ui/codelist/constants';

import ComponentLoader from 'components/molecules/ComponentLoader';
import fetch from 'features/common/fetch';

const codelistItem = PropTypes.shape({
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	company: PropTypes.string,
	language: PropTypes.number,
	shortDescription: PropTypes.string,
	description: PropTypes.string,
});

const empty = [];

const codelistProvider =
	(storeKey, propName, hideLoading = false) =>
	(WrappedComponent) => {
		class Codelists extends Component {
			componentDidMount() {
				const { [propName]: codelist, loadCodelist } = this.props;

				if (!notEmpty(codelist.values)) {
					loadCodelist({ storeKey });
				}
			}

			handleOnReload = () => {
				this.props.loadCodelist({ storeKey });
			};

			render() {
				const { [propName]: codelist, ...rest } = this.props;

				const propsToPassThru = {
					...rest,
					[propName]: codelist.values || empty,
				};

				if (hideLoading) return <WrappedComponent {...propsToPassThru} />;

				return (
					<ComponentLoader
						fetchStorePath={`${fetch.constants.urls.codeTable}.${storeKey}`}
						onReload={this.handleOnReload}
					>
						<WrappedComponent {...propsToPassThru} />
					</ComponentLoader>
				);
			}
		}

		Codelists.propTypes = {
			loadCodelist: PropTypes.func.isRequired,
			[propName]: PropTypes.shape({
				values: PropTypes.arrayOf(codelistItem),
			}),
		};

		Codelists.defaultProps = {
			[propName]: {
				values: [],
				loading: '',
			},
		};

		return connect(
			(state) => ({
				[propName]: state.codelists[storeKey],
			}),
			(dispatch) => {
				return {
					loadCodelist: ({ storeKey }) =>
						dispatch(
							fetch.actions.get(fetch.constants.urls.codeTable, {
								uniqueReqID: storeKey,
								replaceParams: { storeKey },
								onRequest: [
									createAction(codelistActionTypes.CODELIST_LOAD_DATA_REQUEST, () => ({
										codelistStoreKey: storeKey,
									})),
								],
								onSuccess: [
									createAction(codelistActionTypes.CODELIST_LOAD_DATA_SUCCESS, ({ body }) => ({
										codelistStoreKey: storeKey,
										codelistData: body.values,
									})),
								],
								onError: [
									createAction(codelistActionTypes.CODELIST_LOAD_DATA_FAIL, () => ({
										codelistStoreKey: storeKey,
									})),
								],
							}),
						),
				};
			},
		)(Codelists);
	};

export default codelistProvider;
